import { Component, defineComponent } from '@decify/cell-shopify/client';
import './Collapsible.scss';
export const collapsibleName = 'Collapsible';
export const collapsibleTagName = 'cell-component-collapsible';
export const collapsibleExpandEvent = 'expand';
export const collapsibleCollapseEvent = 'collapse';
export class Collapsible extends Component {
    static get observedAttributes() {
        return ['hidden'];
    }
    constructor() {
        super(collapsibleName);
    }
    componentDidUpdate(name) {
        // Ignore initial update.
        // See https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_custom_elements#responding_to_attribute_changes:~:text=Note%20that%20if%20the%20element%27s%20HTML%20declaration%20includes%20an%20observed%20attribute%2C%20then%20attributeChangedCallback()%20will%20be%20called%20after%20the%20attribute%20is%20initialized%2C%20when%20the%20element%27s%20declaration%20is%20parsed%20for%20the%20first%20time.
        if (!this.mounted)
            return;
        switch (name) {
            case 'hidden':
                this.style.overflow = 'hidden';
                const keyframes = {
                    height: ['0px', `${this.scrollHeight}px`],
                    visibility: ['hidden', 'visible'],
                };
                this.animate(keyframes, {
                    duration: 300,
                    direction: this.open ? 'normal' : 'reverse',
                    easing: 'cubic-bezier(0.75, 0, 0.175, 1)',
                }).onfinish = () => {
                    this.style.overflow = this.open ? 'visible' : 'hidden';
                };
                this.publish(this.open ? collapsibleExpandEvent : collapsibleCollapseEvent);
                break;
        }
    }
    get open() {
        return !this.hasAttribute('hidden');
    }
}
defineComponent(collapsibleTagName, Collapsible);
